import { render, staticRenderFns } from "./addFaq.vue?vue&type=template&id=7cdcb2e8&"
import script from "./addFaq.vue?vue&type=script&lang=js&"
export * from "./addFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports